import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  prepare
} from '@/utils/weixin'
import {
  parseTime
} from '@/utils/ruoyi'
import i18n from './assets/i18n/i18n'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import eIconPicker from 'e-icon-picker'
import 'e-icon-picker/lib/symbol.js' // 基本彩色图标库
import { v4 as UUIDV4 } from 'uuid'
import { saveActionRecord } from '@/api/buriedPoint'
import 'font-awesome/css/font-awesome.min.css' // font-awesome 图标库
import 'element-ui/lib/theme-chalk/icon.css'
import { newMessage } from './utils/resetMessage'
import Meta from 'vue-meta'

import Info from '@/components/info/info-plugin'
import jquery from 'jquery'
import Vant, {
  Lazyload
} from 'vant'

import 'vant/lib/index.css'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import axios from 'axios'

import 'e-icon-picker/lib/index.css'

import VueAMap from 'vue-amap'

import SearchHistory from '@/utils/history'
global.jquery = global.$ = jquery
Vue.prototype.parseTime = parseTime

Vue.config.productionTip = false
Vue.use(ElementUI) // element-ui 图标库
Vue.use(eIconPicker, { FontAwesome: true, ElementUI: true, eIcon: true, eIconSymbol: true })
Vue.use(Meta)
Vue.use(Info)

Vue.use(Lazyload, {
  lazyComponent: true
})
Vue.use(Vant)
Vue.use(preview)
Vue.use(Viewer)
Vue.prototype.$axios = axios

prepare(Vue)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  // 高德key
  key: '6b3e2660902feb1a7676dafc2cb978d0', // 高德 Key
  // 插件集合 （插件按需引入）
  plugin: [
    'AMap.Autocomplete', // 输入提示插件
    'AMap.PlaceSearch', // POI搜索插件
    'AMap.Scale', // 右下角缩略图插件 比例尺
    'AMap.OverView', // 地图鹰眼插件
    'AMap.ToolBar', // 地图工具条
    'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    'AMap.Geocoder',
    'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
    'AMap.MarkerClusterer',
    'AMap.AMapManager',
    'AMap.Marker'
  ],
  v: '1.4.15', // 插件
  uiVersion: '1.0.11' // ui版本号，也是需要写
})
Vue.prototype.$searchHistory = SearchHistory
Vue.prototype.$message = newMessage
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

// 自定义埋点指令
Vue.directive( 'track', {
  bind : ( el, binding, vnode ) => {
    if ( binding.value ) {
      // 这里参数是根据自己业务可以自己定义
      let pointId = localStorage.getItem( 'pointId' )
      if ( !pointId ) {
        pointId = UUIDV4()
        localStorage.setItem( 'pointId', pointId )
      }

      const params = {
        operType : binding.value.operType,
        platform : 'MOBILE_WEB',
        operDescription : binding.value.desc,
        page : binding.value.page,
        triggerType : binding.value.triggerType,
        pointId : pointId,
      }

      if(!params.operType){
        return
      }

      const location = window.location.href
      params.pageUrl = location

      // 如果是浏览类型，直接保存
      if ( binding.value.triggerType == 'browse' ) {
        saveActionRecord( params )
        // 调用后台接口保存数据
      } else if ( binding.value.triggerType == 'click' ) {
        // 如果是click类型，监听click事件
        el.addEventListener( 'click', ( event ) => {
          // 打印上面定义的参数属性
          // 调用后台接口保存数据
          saveActionRecord( params )
        }, false )
      }
    }
  }
} )



// WEBPACK FOOTER //
// ./src/main.js